<template>
  <div>
    <div class="form-group mb-4">
      <label for="accreditations_samples_types">
        De acuerdo con las actividades que realizará (toma y/o procesamiento de muestras), al tipo de muestras
        que manejará y/o a los CRETI que utilizará, especifique el equipo de protección personal que utilizará:
      </label>
      <textarea placeholder="Escriba su respuesta..."
                rows="5"
                name="accreditations_samples_types"
                cols="50"
                id="accreditations_samples_types"
                v-model="questionnaire.accreditations_samples_types"
                class="form-control"></textarea>
    </div>

    <div class="form-group mb-4">
      <p>
        ¿El laboratorio donde realizará el proyecto cuenta con manual o manuales de procedimientos?
      </p>

      <!-- Question 13 -->
      <div class="form-check form-check-inline">
        <input id="question-13-radio-1" data-toggle="collapse"
               data-target=".question-13-collapse:not(.show)" name="question_13"
               type="radio"
               value="1"
               class="form-check-input show-collapse"
               :checked="questionnaire.question_13"
               @change="addValidation('question_13')"
               aria-expanded="true">
        <label for="question-13-radio-1"
               class="form-check-label">Si</label>
      </div>
      
      <div class="form-check form-check-inline">
        <input id="question-13-radio-2" data-toggle="collapse"
               data-target=".question-13-collapse.show"
               name="question_13" type="radio"
               value=""
               :checked="questionnaire.question_13 === false"
               @change="removeValidation('question_13')"
               class="form-check-input">
        <label for="question-13-radio-2"
               class="form-check-label">No</label>
      </div>
      <div data-name="question_13"></div>
    </div>

    <div class="question-13-collapse collapse" :class="{ 'show': questionnaire.question_13 === true }">
      <div class="form-group mb-4">
        <label for="accreditations_researcher_id">
          Seleccione el investigador principal o coinvestigador del proyecto acreditado como responsable para el manejo integral
          de RPBI’s y CRETI’s del curso de “Bioseguridad en proyectos de investigación” o el curso CITI “Initial Biosafety Training”
        </label>
        <select id="accreditations_researcher_id"
                name="accreditations_researcher_id"
                class="form-control search-accreditations-researcher select2-input">
          <option v-if="questionnaire.accreditations_researcher"
                  selected :value="questionnaire.accreditations_researcher.id">
            {{ questionnaire.accreditations_researcher.full_name }}
          </option>
        </select>
      </div>

      <div class="form-group mb-4">
        <p class="text-muted">
          NOTA: Si el proyecto es externo al INSP, se requiere anexar la contancia de acrecitación para el manejo integral
          de RPBI'S y CRETI'S:
        </p>
  
        <div class="alert alert-warning" role="alert"
             v-if="questionnaire.accreditations_letter_path">
          Se ha cargado previamente un <strong>
          <a :href="`/${questionnaire.accreditations_letter_path}`"
             target="_blank">
            Comprobante</a></strong>, para cambiar este archivo de click en "Seleccione el comprobante del curso"
        </div>
  
        <div class="custom-file">
          <input data-id="accreditations_letter"
                 accept="application/pdf"
                 name="accreditations_letter"
                 type="file"
                 id="accreditations_letter"
                 ref="accreditations_letter"
                 class="custom-file-input"
                 data-target="accreditations_letter"
                 data-text="Incorpore la carta responsiva de la(s) Institución(es) colaboradora(s) por el manejo de muestras y la adecuada disposición de los residuos."
                 data-info="accreditations_letter_info"
                 @change="setFile('accreditations_letter')">
          <label for="accreditations_letter" class="custom-file-label">Seleccione el comprobante del curso</label>
        </div>
      </div>

      <div class="form-group mb-4">
        <p class="text-muted">
          NOTA: Cuando el protocolo se realice en colaboración con otras instituciones e incluya la toma de cualquier muestra de origen humano, animal o
          de algún patógeno (RPBIs), así como el manejo de algún reactivo peligroso (CRETI), se requiere anexar una carta de la o las instituciones
          que se responsabilizarán de tomar, procesar, transportar o desechar las muestras o reactivos.
        </p>
  
        <div class="alert alert-warning" role="alert"
             v-if="questionnaire.accreditations_collaboration_letter_path">
          Se ha cargado previamente una <strong>
          <a :href="`/${questionnaire.accreditations_collaboration_letter_path}`"
             target="_blank">
            Carta responsiva</a></strong>, para cambiar este archivo de click en "Seleccione la carta responsiva"
        </div>
  
        <div class="custom-file">
          <input data-id="accreditations_collaboration_letter"
                 accept="application/pdf"
                 name="accreditations_collaboration_letter"
                 type="file"
                 id="accreditations_collaboration_letter"
                 ref="accreditations_collaboration_letter"
                 class="custom-file-input"
                 data-target="accreditations_collaboration_letter"
                 data-text="Incorpore la carta responsiva de la(s) Institución(es) colaboradora(s) por el manejo de muestras y la adecuada disposición de los residuos."
                 data-info="accreditations_collaboration_letter_info"
                 @change="setFile('accreditations_collaboration_letter')">
          <label for="accreditations_collaboration_letter" class="custom-file-label">Seleccione la carta responsiva</label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { AlertManager } from '../../../utils/AlertManager'
  import autosize from 'autosize'
  
  export default {
    name: 'SectionFive',
    props: {
      questionnaire: Object,
      protocol: Object,
    },
    data: () => ({
      fields: {
        question_13: [
          'accreditations_researcher_id',
        ],
      },
    }),
    methods: {
      ...mapActions({
        getResearchers: 'protocols/rpbiResearchers',
      }),
      
      addValidation (question) {
        const $formBio = $('.biosecurity-form')
        
        this.fields[question].forEach(field => {
          $formBio.find(`#${field}`).rules('add', {
            required: true,
            messages: {
              required: 'Este campo es requerido',
            },
          })
        })
        
        this.questionnaire[question] = true
      },
      removeValidation (question, value = false) {
        const $formBio = $('.biosecurity-form')
        
        this.fields[question].forEach(field => {
          $formBio.find(`#${field}`).rules('remove')
        })
        
        this.questionnaire[question] = value
      },
      setFile (field) {
        const file = this.$refs[field].files[0]

        if(file.type.indexOf('pdf') === -1) {
          AlertManager.error(`El formato del archivo ${file.name} no es aceptado. Seleccione un archivo PDF`, {
            timeout: 10000,
          })

          $(this.$refs[field]).val('')
          
          return
        }
        
        if (!this.checkFileSize(file)) {
          AlertManager.error(`El tamaño máximo de archivo es de ${ (this.isAdmin() ? 5 : 2) }MB`)
          
          $(this.$refs[field]).val('')

          return
        }
        
        if(!this.checkFileType(file)) {
          AlertManager.error('Seleccione un archivo PDF.')
          
          $(this.$refs[field]).val('')

          return
        }

        this.questionnaire[field] = file
      },
      checkFileSize(file) {
        let maxFileSize = (this.isAdmin() ? 5 : 2) * 1024 * 1024 // 2MB
        
        const fileSize  = file.size
        
        return fileSize <= maxFileSize;
      },
      checkFileType(file) {
        const extension = file.name.slice((Math.max(0, file.name.lastIndexOf('.')) || Infinity) + 1)
        
        return !(extension && extension.toLowerCase() !== 'pdf');
      },
      isAdmin () {
        const roles = ['root', 'administrador']
        
        return this.user && this.user.roles && this.user.roles.some(role => roles.includes(role.key))
      },
    },
    computed: {
      ...mapGetters(['user']),
      ...mapGetters({
        researchers: 'protocols/rpbiResearchers',
      }),
      openTabFive() {
        return [,
          this.questionnaire.question_1,
          this.questionnaire.question_2,
          this.questionnaire.question_3,
          this.questionnaire.question_4,
        ]
      }
    },
    watch: {
      openTabFive() {
        if (!this.questionnaire.question_1 && !this.questionnaire.question_2 && !this.questionnaire.question_3 && !this.questionnaire.question_4) {
          for(let field in this.fields) {
            if (this.questionnaire[field] === null) {
              this.questionnaire[field] = null
              this.removeValidation(field, null)
            }
          }
        }
      }
    },
    async mounted () {
      const vm = this
  
      autosize($('textarea', this.$el))

      await this.getResearchers({
        protocol: vm.protocol,
      })

      $('#accreditations_samples_types').rules('add', {
        required: function (element) {
          return vm.questionnaire.question_1 || vm.questionnaire.question_2 || vm.questionnaire.question_3 || vm.questionnaire.question_4
        },
        messages: {
          required: 'Este campo es requerido',
        },
      })

      /**
       * select2 - Search funders
       */
      this.$search = $('.search-accreditations-researcher')
      this.$search.select2({
        placeholder: 'Seleccione un investigador',
        language: {
          searching: function() {
            return 'Buscando investigadores...';
          },
          noResults: function () {
            return 'No se encontraron resultados'
          },
        },
        ajax: {
          url: '/api/researchers',
          dataType: 'json',
          headers: {
            'Authorization': `Bearer ${window.access_token}`,
          },
          data (params) {
            return {
              q: params.term,
              page: params.page || 1,
              protocol: vm.protocol.id,
              course: 'rpbi',
            }
          },
          processResults (data, params) {
            params.page = params.page || 1

            return {
              results: data.data,
              pagination: {
                more: (params.page * 10) < data.meta.total,
              },
            }
          },
        },
      })

      this.$search.on('select2:select', function (e) {
        vm.questionnaire.accreditations_researcher_id = e.params.data.user_id
      })
    },
  }
</script>
